let pagevisit = 0;
let dirArray = ['',];
let pageload = false;
let closed = false; 

const setClosed = (value) =>{
    closed = value;
}
const getClosed = () =>{
    return closed;
}



const getPageload = () => {
    return pageload;
};
const setPageload = (type) => {
    pageload = type;
};



const getPageVisit = () =>{
    return pagevisit;
};
const changePageVisit = (number) =>{
    pagevisit += number;
    return pagevisit;
};

const pushDirArray = (value) =>{
    
    dirArray.push(value);
};
const removeDirArray = (value) => {
    dirArray.splice(-1, 1);
};
const getDirArray = () =>{
    return dirArray;
};



export { getPageVisit, changePageVisit, pushDirArray, removeDirArray, getDirArray, getPageload, setPageload };
